import type { HTMLAttributes, PropsWithChildren, ReactNode } from "react";

import type { ButtonSize } from "@/src/components/ui/Button/buttonClassName";

import { AppLink } from "@/src/components/navigation/AppLink";
import { buttonClassName } from "@/src/components/ui/Button/buttonClassName";

type ButtonLinkProps = PropsWithChildren<
  {
    readonly darkBackground?: boolean;
    readonly href: string;
    readonly prefetch?: "auto" | false;
    readonly size: ButtonSize;
  } & HTMLAttributes<HTMLAnchorElement>
>;

export function ButtonLink({
  children,
  className,
  darkBackground = false,
  href,
  prefetch = "auto",
  size,
}: ButtonLinkProps): ReactNode {
  const classNames = buttonClassName(className, darkBackground, false, size);
  return (
    <AppLink className={classNames} href={href} prefetch={prefetch}>
      {children}
    </AppLink>
  );
}
